// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flash-btn:hover {\n  cursor: pointer;\n  background-color: white;\n  color: rgb(187, 14, 61);\n  transition: all 0.3s ease;\n}\n\n@media (max-height: 800px) {\n  .submit-files-dropzone {\n    padding: 5rem !important;\n  }\n  .submit-files-dropzone i {\n    font-size: 2.5em !important;\n  }\n  .submit-files-dropzone-header {\n    font-size: 1.2em !important;\n  }\n  .submit-files-dropzone .mdl-button {\n    margin-top: 1rem !important;\n  }\n}\n", ""]);
// Exports
module.exports = exports;
